import { AppRoutePath } from 'Pages/routes';
import {
  BookingFormCustomerInputs
} from 'Common/context/BookingFormContextProvider/types';
import {
  BookingFormValues
} from 'Common/components/BookingForm';

export const getAppointmentRequestStartDateTimeV3Url = (
  serviceProviderId: string,
  serviceOfferingUid: string,
) => {
  const url = AppRoutePath.APPOINTMENT_REQUEST_V3_SELECT_START_DATE_TIME
    .replace('[serviceProviderId]', serviceProviderId)
    .replace('[serviceOfferingUid]', serviceOfferingUid);

  return url;
};

export const getAppointmentRequestSummaryV3Url = (
  serviceProviderId: string,
) => {
  const url = AppRoutePath.APPOINTMENT_REQUEST_V3_SUMMARY
    .replace('[serviceProviderId]', serviceProviderId);

  return url;
};

type directCustomerInputs = Pick<BookingFormCustomerInputs[number], 'uid' | 'required'>[]
type directSelections = Pick<NonNullable<BookingFormValues['customerInputSelections']>[number], 'customerInputUid' | 'optionValue'>[]

export const validateSelections = (
  directCustomerInputs: directCustomerInputs,
  directSelections: directSelections,
) => {
  const uidsWithErr = directCustomerInputs.map(ci => {
    if (ci.required) {
      if (directSelections) {
        const val = directSelections.find(d => d.customerInputUid === ci.uid);
        if (!val?.optionValue) {
          return ci.uid;
        }
      } else {
        return ci.uid;
      }
    }
  }).filter(s => Boolean(s)) as string[];

  return uidsWithErr;
};

